import { render, staticRenderFns } from "./PurchaseRecordList.vue?vue&type=template&id=c3a098f0&scoped=true&"
import script from "./PurchaseRecordList.vue?vue&type=script&lang=js&"
export * from "./PurchaseRecordList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRecordList.vue?vue&type=style&index=0&id=c3a098f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a098f0",
  null
  
)

export default component.exports